/**
 * useRenameConsulta — updates the `label` field on a `consultas` row
 * scoped to the current user.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { useProfileId } from "@/features/onboarding/hooks/useProfileId";
import { queryKeys } from "@/lib/api/queryKeys";

interface RenameConsultaInput {
  id: string;
  label: string;
}

export function useRenameConsulta() {
  const qc = useQueryClient();
  const { client } = useSupabaseClient();
  const { profileId } = useProfileId();

  return useMutation<void, Error, RenameConsultaInput>({
    mutationFn: async ({ id, label }) => {
      if (!profileId) throw new Error("Sessão não pronta. Tente novamente.");
      const { error } = await client
        .from("consultas")
        .update({ label })
        .eq("id", id)
        .eq("user_id", profileId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.consultas.all });
    },
  });
}
